import { defer } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { useEventSettings } from '../../../data/hooks/events/useEventSettings';
import Icon from '../icons/Icon';
import { adjustLuminance } from './adjustLuminance';
import './EmptyScreenContentPlaceholder.scss';

const EmptyScreenContentPlaceholder = (props) => {
    const { event, icon, label, title, children } = props,
        contentRef = useRef(),
        [size, setSize] = useState(0),
        { secondary_color: secondaryColor } = useEventSettings(event.id),
        startColor = adjustLuminance(secondaryColor, 0.3),
        endColor = adjustLuminance(secondaryColor, 0.9);

    useEffect(() => {
        defer(handleUpdateSize);
        window.addEventListener('resize', handleUpdateSize);
        return () => window.removeEventListener('resize', handleUpdateSize);
    }, []);

    function handleUpdateSize() {
        let width = contentRef.current?.getBoundingClientRect().width;
        if (width && size != width) {
            setSize(width);
        }
    }

    return (
        <div className="EmptyScreenContentPlaceholder fill-container VerticalCenter">
            <div
                ref={contentRef}
                style={{
                    height: size,
                    background: `linear-gradient(45deg, ${startColor} 0%, ${endColor} 100%)`,
                }}>
                <div>
                    <Icon src={icon} color={secondaryColor} />
                    <h1>{title}</h1>
                </div>
                <div>{label}</div>
                {children ? <div>{children}</div> : null}
            </div>
        </div>
    );
};

export default EmptyScreenContentPlaceholder;
